


























































































































































































































































































































































































































































































































import * as _ from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  getGuanchazhibiaoAndBiaoqian,
  getGuanchazhibiaoChushizhi,
  saveGuanchazhibiaoAndBiaoqian,
} from "@/request/idr";
import Yanse from "./yanse.vue";
import Wenli from "./wenli.vue";
import Biaoqian from "./biaoqian.vue";
import Preview from "./preview.vue";
import CsPicControl from "./cornerstone-pic/cornerstone-pic.vue";
import CustomCut from "./cornerstone-pic/custom-cut.vue";
@Component({
  components: {
    Yanse,
    Wenli,
    Biaoqian,
    Preview,
    CsPicControl,
    CustomCut,
  },
})
export default class IdrTongueBiaozhu extends Vue {
  private tongueId: any = "";
  private options: any = {};
  private tongue: any = {
    舌象照片: {},
  };
  private ifShowBidui: boolean = false;
  private cPicType: any = "origin";
  private currentPicSrc: any = "";
  private cPart: any = "中医观察指标";
  private cYingxiangPart: any = "";
  private yanse: any = {};
  private ifShowPreview: boolean = false;
  private control: any = "";
  private ifShowCustomCut: boolean = false;
  /**
   * @description 跳转舌图比对
   */
  private jumpBidui() {
    this.$router.push({
      path: "/main/idr/tongue-bidui-list",
      query: {
        tongue_id: this.tongueId,
      },
    });
  }
  /**
   * @description 获取可选项的备选值
   */
  private fetchChushizhi() {
    return new Promise((resolve, reject) => {
      getGuanchazhibiaoChushizhi(this)
        .then((data: any) => {
          this.options = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获得中医观察指标详情
   */
  private fetchDetail() {
    const params: any = {
      params: {
        tongue_id: this.tongueId,
      },
    };
    getGuanchazhibiaoAndBiaoqian(this, params).then((data: any) => {
      this.tongue = data;
      this.currentPicSrc = this.tongue["舌象照片"]["分割前图片"];
    });
  }
  /**
   * @description 切换当前展示的图片
   */
  private changeCurrentPic(src, type) {
    this.currentPicSrc = src;
    this.cPicType = type;
    this.$nextTick().then(() => {
      (this.$refs.picControl as any).reload();
    });
  }
  /**
   * @description 打开预览
   */
  private openPreview() {
    this.ifShowPreview = true;
  }
  /**
   * @description 关闭预览
   */
  private closePreview() {
    this.ifShowPreview = false;
  }
  /**
   * @description 返回图片列表
   */
  private backList() {
    this.$router.push({
      path: "/main/idr/tongue-list",
    });
  }
  /**
   * @description part变化
   */
  private partChange(part) {
    this.cYingxiangPart = "";
    this.cPart = part;
  }
  /**
   * @description 影像组学参数变化
   */
  private yingxiangPartChange(ev) {
    this.cPart = "";
    this.cYingxiangPart = ev;
  }
  /**
   * @description 保存中医观察指标
   */
  private saveGuanchazhibiao(guiji: any) {
    const params: any = _.cloneDeep(this.tongue);
    params["轨迹"] = guiji;
    saveGuanchazhibiaoAndBiaoqian(this, params).then((data: any) => {
      this.$message.success("标注成功");
      this.fetchDetail();
    });
  }
  /**
   * @description 保存舌图标签
   */
  private saveBiaoqian(guiji: any) {
    (this.$refs.biaoqian as any).saveBiaoqian(guiji);
  }
  /**
   * @description 点击保存按钮
   */
  private save() {
    const guiji = (this.$refs.picControl as any).collectData();
    if (this.cPart === "中医观察指标") {
      this.saveGuanchazhibiao(guiji);
    } else if (this.cPart === "舌图标签") {
      this.saveBiaoqian(guiji);
    }
  }
  // 图片控制
  /**
   * @description 齿痕
   */
  private startChihen() {
    if (this.cPicType === "cutted") {
      return;
    }
    (this.$refs.picControl as any).chihen();
    this.control = this.control === "齿痕" ? "" : "齿痕";
  }
  /**
   * @description 裂纹
   */
  private startLiewen() {
    if (this.cPicType === "cutted") {
      return;
    }
    (this.$refs.picControl as any).liewen();
    this.control = this.control === "裂纹" ? "" : "裂纹";
  }
  /**
   * @description 点刺
   */
  private startDianci() {
    if (this.cPicType === "cutted") {
      return;
    }
    (this.$refs.picControl as any).dianci();
    this.control = this.control === "点刺" ? "" : "点刺";
  }
  /**
   * @description 瘀斑瘀点
   */
  private startYubanyudian() {
    if (this.cPicType === "cutted") {
      return;
    }
    (this.$refs.picControl as any).yubanyudian();
    this.control = this.control === "瘀斑瘀点" ? "" : "瘀斑瘀点";
  }
  /**
   * @description 标尺
   */
  private startBiaochi() {
    if (this.cPicType === "cutted") {
      return;
    }
    (this.$refs.picControl as any).biaochi();
    this.control = this.control === "标尺" ? "" : "标尺";
  }
  /**
   * @description 手动分割
   */
  private startCustomCut() {
    if (this.cPicType === "origin") {
      return;
    }
    this.control = this.control === "手动分割" ? "" : "手动分割";
    this.ifShowCustomCut = true;
  }
  /**
   * @description 手动分割关闭
   */
  private customCutClose() {
    this.ifShowCustomCut = false;
    this.fetchDetail();
  }
  /**
   * @description 移动
   */
  private yidong() {
    (this.$refs.picControl as any).yidong();
    this.control = this.control === "移动" ? "" : "移动";
  }
  /**
   * @description 缩放
   */
  private suofang() {
    (this.$refs.picControl as any).suofang();
    this.control = this.control === "缩放" ? "" : "缩放";
  }
  /**
   * @description 透镜
   */
  private toujing() {
    (this.$refs.picControl as any).toujing();
    this.control = this.control === "透镜" ? "" : "透镜";
  }
  /**
   * @description 旋转
   */
  private xuanzhuan() {
    (this.$refs.picControl as any).xuanzhuan();
    this.control = this.control === "旋转" ? "" : "旋转";
  }
  /**
   * @description 截屏
   */
  private jieping() {
    (this.$refs.picControl as any).jieping();
  }
  /**
   * @description 还原
   */
  private huanyuan() {
    (this.$refs.picControl as any).huanyuan();
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.tongueId = this.$route.query.tongue_id;
    this.fetchChushizhi().then(() => {
      this.fetchDetail();
    });
  }
}
